import React from 'react';
import { useState, useEffect, useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import axios from 'axios';
import { useReactToPrint } from 'react-to-print';
import ReactPaginate from 'react-paginate';

const Vendorincome = () => {

  const [editIncome, seteditIncome] = useState([]);
  const [itemsPerPage] = useState(10);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const geteditIncome = async () => {
    try {
      const response = await axios.get("https://apimlm.bloomitsolutions.in/auth/getAllUsersIncomeData");
      const empData = response.data;
      seteditIncome(empData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const PER_PAGE = 10;
  const [currentPage, setCurrentPage] = useState(0);
  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage)
  }
  const offset = currentPage * PER_PAGE;
  const pageCount = Math.ceil(editIncome.length / PER_PAGE);


  useEffect(() => {
    geteditIncome();
  }, []);


  return (
    <div>

      <Container>

        <div className='container'>
          <div className='row '>
            <div className='col-lg-12 '>
              <div className='row ' style={{ display: "flex" }} >
              </div>
              <div className="row ">
                <div className="col-lg-6 mt-4  ">

                </div>
              </div>

              <div className="row mt-4">
                <div className="col-lg-12">
                  <div className="card" ref={componentRef}>
                    <div className="card-header" style={{ backgroundColor: "rgb(0,156,216)", color: 'white' }}>
                      <h4> Vendor Income Details </h4>
                    </div>
                    <div className="card-body">
                      {/* <div className=""> */}
                      <div className="mb-2">
                        {/* <Button className='rounded-0'>Copy</Button>
                          <Button className='rounded-0'>Excel</Button> */}
                        <Button className='rounded-0' onClick={handlePrint}>Download PDF</Button>
                        {/* <Button className='rounded-0'>Column visibility</Button> */}
                      </div>
                      {/* </div> */}
                      <form>
                        <div className="card-body">
                          <div className='table-responsive'>
                            <table className="table table-bordered">

                              <thead>
                                <tr>
                                  <th scope="col">Sl No</th>
                                  <th scope="col">User iD</th>
                                  <th scope="col">Direct Income</th>
                                  <th scope="col">Bonus</th>
                                  <th scope="col">UplineIncome</th>
                                  <th scope="col">Generation Income</th>
                                  <th scope="col">Level</th>
                                  <th scope="col">Created At</th>
                                  <th scope="col">Updated At</th>
                                  <th scope="col">Username</th>
                                  <th scope="col">Email</th>
                                  {/* <th scope="col">Status</th> */}


                                </tr>
                              </thead>

                              <tbody>
                                {
                                  editIncome.slice(offset, offset + PER_PAGE).map((product, index) => (
                                    <tr key={index}>
                                      <td>{product.id}</td>
                                      <td>{product.userId}</td>
                                      <td>{product.directIncome}</td>
                                      <td>{product.bonus}</td>
                                      <td>
                                        {/* <img */}
                                        {product.uplineIncome}
                                        {/* alt={product.title} */}
                                        {/* width="50" */}
                                        {/* /> */}

                                      </td>
                                      <td>{product.generationIncome}</td>
                                      <td>{product.level}</td>
                                      <td>{product.createdAt}</td>
                                      <td>{product.updatedAt}</td>
                                      <td>{product.User.username}</td>
                                      <td>{product.User.email}</td>
                                      {/* <td>
                                  <button className='btn btn-primary'>Update</button>
                                
                                </td> */}
                                    </tr>
                                  ))
                                }
                              </tbody>

                            </table>

                            <div className="mb-4 mt-4">
                              <ReactPaginate
                                previousLabel={"Previous"}
                                nextLabel={"Next"}
                                breakLabel={"..."}
                                pageCount={pageCount}
                                marginPagesDisplayed={5}
                                pageRangeDisplayed={3}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination  justify-content-center"}
                                pageClassName={"page-item "}
                                pageLinkClassName={"page-link"}
                                previousClassName={"page-item"}
                                previousLinkClassName={"page-link"}
                                nextClassName={"page-item"}
                                nextLinkClassName={"page-link"}
                                breakClassName={"page-item"}
                                breakLinkClassName={"page-link"}
                                activeClassName={"active primary"}
                              />
                            </div>
                            {/* <nav aria-label="...">
                              <ul class="pagination">
                                <li class="page-item disabled">
                                  <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Previous</a>
                                </li>
                                <li class="page-item active"><a class="page-link" href="#">1</a></li>
                                <li class="page-item " aria-current="page">
                                  <a class="page-link" href="#">2</a>
                                </li>
                                <li class="page-item"><a class="page-link" href="#">3</a></li>
                                <li class="page-item">
                                  <a class="page-link" href="#">Next</a>
                                </li>
                              </ul>
                            </nav> */}
                          </div>

                        </div>
                        {/* /.card-body */}
                      </form>
                    </div>
                  </div>
                </div>
              </div>










            </div>

          </div>


        </div>



      </Container>



    </div>
  )
}

export default Vendorincome;